import { Text } from "../../../../atoms/Text";

/**
 * Red minus in the lead slot. On a deduction the kind matters more than the
 * approval state, so it takes the dot's place rather than sitting beside one.
 */
export const DeductionLead = () => (
  <Text
    as="span"
    aria-hidden
    variant="inherit"
    className="font-bold leading-none text-(length:--ledger-text-cell) text-content-error"
  >
    −
  </Text>
);
